import { Container, Grid, useMediaQuery } from '@material-ui/core'
import React, { useState, useEffect } from 'react'
import { ButtonAddHLPure, ButtonHLPure, DialogSystemGLPure, DialogYesNoHLPure, DropDownBtnHLPure, GridSelectionHLPure, SearchBarHLPure, SimpleLoading, LabelModalPure } from '../../pures'
import './digital-vault-alerts.css'
import { filterBy } from '@progress/kendo-data-query'
import AlertDetails from './alert-details'
import AlertReminders from './alert-reminders'
import { useTranslation } from 'react-i18next'
import { DigitalVaultDocumentAction } from '../../actions'

const initialFilter = {
  logic: 'or',
  filters: [
    {
      field: 'name',
      operator: 'contains',
      value: '',
    }
  ],
};

const HeaderColumns = (props) => {
  return <span className={(props.title === props.t('digitalVaultAlertsView.grid.title.1')) ? 'grid-header-one' : 'grid-headers'}>{props.title}</span>;
};

const CellColumnOne = (props) => {
  const { dataItem } = props;

  return (
    <td>
      <div className='grid-cell-double-container-margin-left'>
        <p className='grid-cell-titles'>{dataItem.document.name}</p>
        <p className='grid-cell-subtitles'>{dataItem.document.company.companyName}</p>
      </div>
    </td>
  )
}

const CellColumnText = (props) => {
  const {
    col,
    dataItem,
  } = props;

  let content = ''

  if (col === 2) {
    content = dataItem.name
  } else if (col === 3) {
    content = dataItem.alertTypeRecurrence.key
  }

  return (
    <td>
      <div>
        <p className={'grid-cell-subtitles'}>{content}</p>
      </div>
    </td>
  )
}

const DigitalVaultAlertsView = (props) => {
  const {
    isLoading,
    toggleCompletedRequesting,
    toggleErrorRequesting,
    toggleLoadingRequesting,
    showLoadingRequesting,
    showErrorRequesting,
    showCompletedRequesting,
    messageError,

    companies,
    selectedCompanyId,
    setSelectedCompanyId,
    alerts,
    selectedAlert,
    documentId,
    setSelectedAlert,
    viewDetails,
    setViewDetails,
    viewReminders,
    setViewReminders,
    viewDocument,
    setViewDocument,
    viewDeleteDialog,
    setViewDeleteDialog,
    createUpdateAlert,
    deleteAlert,
    goBack
  } = props;

  const { t } = useTranslation()

  const [alertsDatagrid, setAlertsDatagrid] = useState(alerts);

  useEffect(() => {
    setAlertsDatagrid(alerts);
  }, [alerts]);

  const [alertSearch, setAlertSearch] = useState('');
  const [filter, setFilter] = useState(initialFilter);
  useEffect(() => {
    let newFilter = {
      logic: 'and',
      filters: [
        {
          field: 'name',
          operator: 'contains',
          value: alertSearch,
        }
      ],
    }
    if (selectedCompanyId !== '0') {
      newFilter.filters.push({
        field: 'document.company.id',
        operator: 'eq',
        value: selectedCompanyId,
      })
    }
    setFilter(newFilter);
  }, [alertSearch, selectedCompanyId]);

  const onCompanyDropdownChange = (e) => {
    setSelectedCompanyId(e.target.value)
  }

  const [gridAction, setGridAction] = useState('')

  useEffect(() => {
    window.scrollTo(0, 0)
  }, [viewDocument, viewDetails, viewReminders])

  useEffect(() => {
    if (gridAction === '' || !selectedAlert || !selectedAlert.id) return;

    switch (gridAction) {
      case t('digitalVaultAlertsView.grid.btns.view.detail'):
        setViewDetails(true);
        break;
      case t('digitalVaultAlertsView.grid.btns.reminders'):
        setViewReminders(true);
        break;
      case t('digitalVaultAlertsView.grid.btns.delete'):
        setViewDeleteDialog(true);
        break;
      case t('digitalVaultAlertsView.grid.btns.view.doc'):
        setViewDocument(true);
        break;
      default:
        break;
    }
  }, [selectedAlert, gridAction])

  useEffect(() => {
    setSelectedCompanyId('0')
    setAlertSearch('');
    setViewDetails(false);
    setViewDocument(false);
    setViewReminders(false);
    setSelectedAlert(null);
  }, [documentId])


  const hideFrequency = useMediaQuery('(max-width:1100px)');
  const hideActionsHeader = useMediaQuery('(max-width:912px)');
  const is1200 = useMediaQuery('(max-width:1200px)');
  const isMobile = useMediaQuery('(max-width:912px)')

  const AllHeadersColumns = (props) => <HeaderColumns {...props} t={t} />
  const CellColumnTwo = (props) => <CellColumnText {...props} col={2} />
  const CellColumnThree = (props) => <CellColumnText {...props} col={3} />

  if (isLoading) return <SimpleLoading />

  if (viewDocument) return <DigitalVaultDocumentAction
    documentId={selectedAlert.document.id}
    goBack={() => setViewDocument(false)}
    stateToMaintain={{ selectedCompanyId, viewDocument, viewDetails, viewReminders, selectedAlert, hadDocumentParam: documentId != null }}
  />

  let widthCellOne = '100px'
  let widthCellTwo = '90px'
  let widthCellThree = '40px'
  let widthCellFive = '120px'

  if (is1200) {
    widthCellOne = '80px'
    widthCellTwo = '70px'
  }

  if (hideActionsHeader) {
    widthCellOne = '120px'
    widthCellTwo = '110px'
    widthCellFive = '30px'
  }

  return (
    <>
      <Container disableGutters className='digitalVaultAlertsView'>
        <Grid container spacing={3}>
          {
            viewReminders
              ? <Grid item xs={12}>
                <AlertReminders
                  t={t}
                  alert={selectedAlert}
                  onBack={() => setViewReminders(false)}
                />
              </Grid>
              : viewDetails
                ? <Grid item xs={12}>
                  <AlertDetails
                    t={t}
                    alert={selectedAlert}
                    documentId={documentId}
                    createUpdateAlert={createUpdateAlert}
                    onDelete={() => setViewDeleteDialog(true)}
                    onBack={() => setViewDetails(false)}
                    showDocuments={() => setViewDocument(true)}
                    showReminders={() => setViewReminders(true)}
                  />
                </Grid>
                : null
          }

          {
            !viewDetails && !viewReminders &&
            <>
              <Grid item xs={12}>
                <div className={!documentId ? 'documentsToRequire-navbar' : 'documentsToRequire-navbar'}>
                  {documentId ?
                    <ButtonAddHLPure
                      nameBtn={t('digitalVaultAlertsView.add.alert')}
                      iconAdd
                      onClickBtn={() => setViewDetails(true)}
                    />
                    : <div className='digitalVaultAlertsView-hiddenBtn'></div>}
                  <SearchBarHLPure
                    placeholder={t('digitalVaultAlertsView.search.alerts')}
                    searchValue={alertSearch}
                    onSearchChange={(e) => setAlertSearch(e.target.value)}
                  />

                  <div className='documentsToRequire-filter'>
                    {!documentId &&
                      <DropDownBtnHLPure
                        optionsDropDown={companies}
                        optionsValue={selectedCompanyId}
                        valueItem={'id'}
                        nameOption={'companyName'}
                        onDropDownChange={onCompanyDropdownChange}
                        iconFilter={true}
                      />
                    }
                  </div>
                </div>
              </Grid>
              <Grid item xs={12} className='digitalVaultAlertsView-grid'>
                <GridSelectionHLPure
                  skip={0}
                  take={6}
                  pageable
                  dataGrid={filterBy(alertsDatagrid, filter)}

                  titleRow1={t('digitalVaultAlertsView.grid.title.1')}
                  headerColumnOne={AllHeadersColumns}
                  cellColumnOne={CellColumnOne}
                  widthColumnOne={widthCellOne}
                  minResizableWidth1={'auto'}
                  isCheckedColOne={'documentName'}

                  columnTwo
                  titleRow2={t('digitalVaultAlertsView.grid.title.2')}
                  headerColumnTwo={AllHeadersColumns}
                  cellColumnTwo={CellColumnTwo}
                  widthColumnTwo={widthCellTwo}
                  minResizableWidth2={'auto'}

                  columnThree={!hideFrequency}
                  titleRow3={t('digitalVaultAlertsView.grid.title.3')}
                  headerColumnThree={AllHeadersColumns}
                  cellColumnThree={CellColumnThree}
                  widthColumnThree={widthCellThree}
                  minResizableWidth3={widthCellThree}

                  columnFive
                  columnFiveStyleClass={'digitalVaultAlertsView-cellActions'}
                  titleRow5={t('digitalVaultAlertsView.grid.title.4')}
                  iconOneActive
                  labelOneActions={t('digitalVaultAlertsView.grid.btns.reminders')}
                  iconThirdActive={!goBack}
                  labelThirdActions={t('digitalVaultAlertsView.grid.btns.view.doc')}
                  iconFourthActive
                  labelFourthActions={t('digitalVaultAlertsView.grid.btns.view.detail')}
                  iconTrashActive
                  labelTrashActions={t('digitalVaultAlertsView.grid.btns.delete')}
                  widthColumnFive={widthCellFive}
                  minResizableWidth5={widthCellFive}
                  tooltipTrashIcon={t('button.delete')}
                  onSelectedItem={setSelectedAlert}
                  setNameComponentUser={setGridAction}
                  setShowDetails={() => { /* no ocupo */ }}
                  mobileFunction={isMobile}
                  btnOpenDialog1={(item) => {
                    setSelectedAlert(item);
                    setGridAction(t('digitalVaultAlertsView.grid.btns.view.detail'));
                  }}
                  btnOpenDialogTrash={(item) => {
                    setSelectedAlert(item);
                    setViewDeleteDialog(true);
                  }}
                />
              </Grid>
            </>
          }
          {
            goBack && !viewDetails && !viewDocument && !viewReminders &&
            <Grid item xs={12}>
              <Grid container justify='flex-end'>
                <ButtonHLPure
                  nameBtn={t('button.return')}
                  onClickBtn={goBack}
                />
              </Grid>
            </Grid>
          }
        </Grid>
      </Container>
      {
        viewDeleteDialog &&
        <DialogSystemGLPure
          showConfirm={true}
          confirmTitle={t('digitalVaultAlertsView.modal.delete.title')}
          confirmMessage={
            <>
              {t('digitalVaultAlertsView.modal.delete.question')}{' '}
              <span style={{ fontWeight: 500 }}>
                {selectedAlert?.name}
              </span>
            </>
          }
          labelCancelConfirmation={t('button.cancel')}
          handleConfirmDeleteFlowClose={() => {
            setViewDeleteDialog(false);
          }}
          labelSubmitConfirmation={t('button.delete')}
          handleConfirmDeleteFlowSubmit={deleteAlert}
        />
      }
      <DialogSystemGLPure
        showLoadingRequesting={showLoadingRequesting}
        showCompletedRequesting={showCompletedRequesting}
        showErrorRequesting={showErrorRequesting}
        toggleLoadingRequesting={toggleLoadingRequesting}
        toggleCompletedRequesting={toggleCompletedRequesting}
        toggleErrorRequesting={toggleErrorRequesting}
        message={messageError}
      />
    </>
  )
}

export default DigitalVaultAlertsView